import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

import { Signer } from '@app/models';
import { ErrorHandlerService, DocumentService, AppService, NotyService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';

export type ModalResult = void;
export interface ModalPublicProperties {
  signer: Signer;
}

@Component({
  selector: 'app-sign-link-modal',
  templateUrl: './sign-link-modal.component.html',
  styleUrls: ['./sign-link-modal.component.scss'],
  standalone: false
})
export class SignLinkModalComponent implements ModalPublicProperties {
  @Input() signer: Signer;
  isLoading = false;

  constructor(public modal: NgbActiveModal, public appService: AppService, private documentService: DocumentService, private errorHandlerService: ErrorHandlerService) {}

  createSignLink() {
    this.isLoading = true;
    this.documentService
      .createSignerLink({ publicId: this.signer.public_id })
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: link => (this.signer.link = link),
        error: error => this.errorHandlerService.handle(error)
      });
  }

  deleteSignLink() {
    this.isLoading = true;
    this.documentService
      .deleteSignerLink({ publicId: this.signer.public_id })
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => (this.signer.link = null),
        error: error => this.errorHandlerService.handle(error)
      });
  }
  copySignatureLink(): void {
    this.documentService.copySignatureLink(this.signer);
  }
}
